import React from "react";
import { inject } from "mobx-react";
import { defaultTemplate } from 'core/hoc';
import { BaasicConfirmModalNewTemplate } from "themes/components";

function BaasicConfirmModalNew(props) {
    return <BaasicConfirmModalNewTemplate {...props} />;
}

export default inject((i, props) => {
    return {
        modalParams: props.modalParams || i.rootStore.modalStore.confirmParams
    };
})(defaultTemplate(BaasicConfirmModalNew));
